import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { NotificationsService } from '../../notifications.service';
import { INotification } from '../../notifications.types';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';

@Component({
	selector: 'app-notifications-list',
	styleUrls: ['../../notifications.scss'],
	templateUrl: './notifications-list.component.html'
})
export class NotificationsListComponent implements OnInit, AfterViewInit {
	constructor(private notificationsService: NotificationsService, private router: Router) {
		// if you navigate to this page, they are all read
		this.notificationsService.markAllNotificationsRead().subscribe();
	}

	public notifications: INotification[];
	public notificationCount: number = 0;
	public filterText: string = '';
	public gridDataSource: MatTableDataSource<INotification>;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	public loading: boolean = false;

	public displayedColumns: string[] = ['lastOccurrenceDate', 'message'];

	private filterDebounce: number;

	ngOnInit(): void {
		this.getNotificationsCount();
	}

	ngAfterViewInit(): void {
		this.getNotifications();
	}

	applyFilter(): void {
		if (this.filterDebounce && this.filterDebounce > 0) {
			clearTimeout(this.filterDebounce);
		}
		this.filterDebounce = setTimeout(() => {
			this.getNotifications();
			this.getNotificationsCount();
		}, 500);
	}

	formatMessage(message: string): string {
		let msg: string = message.replace('System.IO.InvalidDataException', '');
		const eom: number = msg.indexOf('could not be found');
		if (eom > -1) {
			msg = msg.substr(0, eom + 'could not be found'.length);
		}

		return msg;
	}

	getMessageWithoutLink(message: string): string {
		const msg: string = message.replace('available here.', '');
		return msg;
	}

	anchorClick(uniqueIdentifier: string, createdDate: string): void {
		this.router.navigate(['/pilotpay/notifications/audit-log', uniqueIdentifier], {
			queryParams: { date: createdDate }
		});
	}

	handlePageChanged(page: PageEvent): void {
		this.getNotifications();
	}

	private getNotificationsCount(): void {
		this.notificationsService.getTotalNotificationsCount(this.filterText).subscribe(c => {
			this.paginator.length = c;
			this.notificationCount = c;
		});
	}

	private getNotifications(): void {
		const start: number = this.paginator.pageIndex * this.paginator.pageSize;
		const end: number = start + this.paginator.pageSize;
		this.loading = true;
		this.notificationsService
			.getPagedNotifications(start, end, false, this.filterText)
			.subscribe((items: INotification[]) => {
				this.notifications = items;
				this.gridDataSource = new MatTableDataSource<INotification>(items);
				this.loading = false;
			});
	}
}
